import { createReducer } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import { fetchCommunicationsSituations, fetchedCommunicationsSituations } from './actions';
import { State } from './types';

export const INITIAL_STATE: State = {
  status: undefined,
  error: undefined,
  data: [],
};

// https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
export default createReducer<State>(INITIAL_STATE, (builder) =>
  builder
    .addCase(fetchCommunicationsSituations, (state) => {
      state.status = 'loading';
    })
    .addCase(fetchedCommunicationsSituations, (state, action) => {
      const { error, payload } = action;
      if (error === true) {
        state.error = payload as RequestError;
        state.status = 'error';
      } else {
        state.data = payload as State['data'];
        state.error = undefined;
        state.status = 'success';
      }
    })
);
